import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { CTA, Text } from '../../../ui/atoms';
import ButtonsBanner from '../../../ui/components/Tutor/ButtonsBanner';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import CardInnerDocument from '../../../ui/atoms/Modals/ModalInnerDocuments/CardInnerDocument';
import { INNER_DOC_CARD_TEMPLATE_COLUMNS } from '../Documents/style';
import { getUrlWithToken } from '../../../utils/common';

export const Legend = styled.div`
  display: grid;
  gap: 38px;
  grid-template-columns: ${INNER_DOC_CARD_TEMPLATE_COLUMNS};
  margin-bottom: 16px;
`;

const Documents = ({ mediaIsPhone, mediaIsTablet, editDetails }) => {
  const [importedDocuments, setImportedDocuments] = useState([]);

  useEffect(() => {
    if (editDetails) {
      setImportedDocuments(editDetails?.inner_documents);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editDetails]);

  return (
    <>
      <Text type="b3" mb={24}>
        Sezione dedicata al caricamento dei documenti relativi al percorso
        formativo che si sta creando.
      </Text>
      <Text type="h2" mb={8}>
        Documenti importati
      </Text>
      <Text type="b3" mb={24}>
        {importedDocuments?.length > 0
          ? `${importedDocuments?.length} documenti importati`
          : 'Nessun documento importato.'}
      </Text>
      {importedDocuments?.length > 0 && (
        <>
          {!(mediaIsPhone || mediaIsTablet) && (
            <Legend className="uppercase">
              <Text type="h3.5">Formato</Text>
              <Text type="h3.5">Titolo</Text>
              <Text type="h3.5">Tipologia</Text>
              <Text type="h3.5">Data</Text>
              <Text type="h3.5">Dimensioni</Text>
            </Legend>
          )}
          {(importedDocuments || []).map((d, i) => (
            <CardInnerDocument key={`doc-${i}`} item={d}>
              <CTA
                type="tertiary"
                btnText="Visualizza"
                icon="eye"
                onClick={() => {
                  const link = document.querySelector(`#doc-link-${d.id}`);
                  link?.click();
                }}
              />
              <a
                href={getUrlWithToken(d?.file_info?.url)}
                className="d-none"
                download={d?.file_info?.file_name}
                id={`doc-link-${d.id}`}
              >
                download-link
              </a>
            </CardInnerDocument>
          ))}
        </>
      )}
      <ButtonsBanner nextEnabled />
    </>
  );
};

Documents.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  editDetails: PropTypes.object,
};

export default connect(
  (state) => {
    const { details: editDetails } = state.tutorCourseList;
    return {
      editDetails,
    };
  },
  (dispatch) => ({})
)(withMediaQueries(Documents));
